import React from 'react';
import PropTypes from 'prop-types';

import WaldogramOneSidedTemplate from './WaldogramOneSidedTemplate';
import WaldogramTwoSidedTemplate from './WaldogramTwoSidedTemplate';
import { WALDOGRAM_PRINT_TYPE } from '../../../apps/web-gallery/constants/web-gallery-waldogram-constants';
import CustomPrintConfiguratorPhotoSelector from '../CustomPrintConfigurator/components/CustomPrintConfiguratorPhotoSelectorModal/CustomPrintConfiguratorPhotoSelectorModal';

const propTypes = {
  printType: PropTypes.oneOf(Object.values(WALDOGRAM_PRINT_TYPE)),
  config: PropTypes.shape({
    emoji: PropTypes.shape({
      id: PropTypes.string,
      unified: PropTypes.string,
    }),
    photos: PropTypes.arrayOf(
      PropTypes.shape({
        photo: PropTypes.shape({
          id: PropTypes.string,
          position: PropTypes.number,
        }),
      }),
    ),
  }),
  selectedPhoto: PropTypes.shape({
    photo: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }),
    position: PropTypes.number.isRequired,
  }),
  onPhotoSelect: PropTypes.func.isRequired,
  onPhotoSet: PropTypes.func.isRequired,
  onPhotoCropboxSet: PropTypes.func.isRequired,
  onCaptionSet: PropTypes.func.isRequired,
  onCabinNameSet: PropTypes.func,
  onIdentityNameSet: PropTypes.func.isRequired,
  onEmojiSet: PropTypes.func.isRequired,
  candidatePhotoGroups: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      label: PropTypes.string,
      total: PropTypes.number,
      photos: PropTypes.array,
      loadMore: PropTypes.func,
    }),
  ),
  externalAddresses: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      address_line_1: PropTypes.string.isRequired,
      address_line_2: PropTypes.string,
      post_code: PropTypes.string.isRequired,
      city: PropTypes.string.isRequired,
      state: PropTypes.string.isRequired,
      country: PropTypes.shape({
        name: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
  ),
  purchasedCustomPrintPhotos: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
    }),
  ),
  mainSlotRef: PropTypes.object,
};

const WaldogramConfigurator = ({
  printType,
  config,
  selectedPhoto,
  onPhotoSelect,
  onPhotoSet,
  onPhotoCropboxSet,
  onCaptionSet,
  onCabinNameSet,
  onIdentityNameSet,
  onEmojiSet,
  candidatePhotoGroups,
  externalAddresses,
  purchasedCustomPrintPhotos,
  mainSlotRef,
}) => {
  return (
    <div className="waldogram-config-wrap">
      {printType === WALDOGRAM_PRINT_TYPE.ONSITE && (
        <WaldogramOneSidedTemplate
          config={config}
          onPhotoSelect={onPhotoSelect}
          onPhotoCropboxSet={onPhotoCropboxSet}
          onCaptionSet={onCaptionSet}
          onCabinNameSet={onCabinNameSet}
          onIdentityNameSet={onIdentityNameSet}
          onEmojiSet={onEmojiSet}
          mainSlotRef={mainSlotRef}
        />
      )}

      {printType === WALDOGRAM_PRINT_TYPE.OFFSITE && (
        <WaldogramTwoSidedTemplate
          config={config}
          onPhotoSelect={onPhotoSelect}
          onPhotoCropboxSet={onPhotoCropboxSet}
          onCaptionSet={onCaptionSet}
          onCabinNameSet={onCabinNameSet}
          onIdentityNameSet={onIdentityNameSet}
          onEmojiSet={onEmojiSet}
          externalAddresses={externalAddresses}
          mainSlotRef={mainSlotRef}
        />
      )}

      <CustomPrintConfiguratorPhotoSelector
        forceOpen={!!selectedPhoto}
        selectedPhoto={selectedPhoto}
        defaultPhotoGroups={candidatePhotoGroups}
        onPhotoConfirm={onPhotoSet}
        onClose={() => onPhotoSelect({})}
        customUploadEnabled
        purchasedCustomPrintPhotos={purchasedCustomPrintPhotos}
      />
    </div>
  );
};

WaldogramConfigurator.propTypes = propTypes;

export default WaldogramConfigurator;
